import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  buttonWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    margin: "40px 0"
  }
});
